// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1h1tn7od{aspect-ratio:unset}\n._2lx21bp4{flex-direction:column}\n._4cvr1h6o{align-items:center}\n._4t3i1osq{height:100%}\n._5ral1dfr{object-fit:cover}\n._bfhk11bn{background-color:var(--ds-background-accent-gray-subtlest,#f1f2f4)}", ""]);
// Exports
module.exports = exports;
